import { doc, getFirestore } from 'firebase/firestore';
import { subscriptionDefaults } from '../../../config/dataDefaults';
import FirebaseDoc from '../abstract/FirebaseDoc';

class SubscriptionState extends FirebaseDoc {
  constructor(root) {
    super(root, {
      ref: doc(getFirestore(), `subscriptions/${root.userImpl.uid}`),
      defaults: subscriptionDefaults(),
    });
  }
}

SubscriptionState.annotations = {
  ...FirebaseDoc.annotations,
};

export default SubscriptionState;
